import React from 'react';
import pluralize from 'pluralize';
import { getPrettyNumber } from '../../../helpers/formatting';

export const RecommendationCard = ({ entity, data }) => {
  if (!data) {
    return (
      <>
        <div className='no-data'>No data available</div>
      </>
    );
  }

  switch (entity) {
    case 'AllBrand':
    case 'Brand':
      return (
        <>
          {data.logo && <img src={data.logo} alt={data.name} className='rec-image' />}
          <div className='rec-name'>{data.name}</div>
        </>
      );

    case 'Category':
      return (
        <>
          {data.exampleProductImage && <img src={data.exampleProductImage} alt={data.name} className='rec-image' />}
          <div className='rec-meta' style={{ fontStyle: 'italic' }}>
            Shop
          </div>
          <div className='rec-name'>{data.name}</div>
        </>
      );

    case 'CuratorGroup':
      return (
        <>
          {data.previewImage && <img src={data.previewImage} alt={data.title} className='rec-image' />}
          <div className='rec-meta'>{data.Industry_name || data.Department_name || data.Category_name}</div>
          <div className='rec-name'>{data.title}</div>
          <div className='rec-meta'>
            By: {data.User_name} (@{data.User_username})
          </div>
          <div className='rec-meta'>
            {data.userCount || 0} {pluralize('curator', data.userCount || 0)}
          </div>
          {data.description && <div className='rec-description'>{data.description}</div>}
        </>
      );

    case 'Collection':
      return (
        <>
          {data.image && <img src={data.image} alt={data.name} className='rec-image' />}
          <div className='rec-name'>{data.name}</div>
          <div className='rec-meta'>
            By: {data.User_name} (@{data.User_username})
          </div>
          {data.description && <div className='rec-description'>{data.description}</div>}
        </>
      );

    case 'Product':
      return (
        <>
          {data.image && <img src={data.image} alt={data.title} className='rec-image' />}
          {(data.brand || data.fallbackPrice) && (
            <div className='rec-meta'>
              {data.brand && <span>{data.brand}</span>}
              {data.brand && data.fallbackPrice && <span> • </span>}
              {data.fallbackPrice && (
                <span>
                  {data.fallbackPriceCurrency || '$'}
                  {data.fallbackPrice}
                </span>
              )}
            </div>
          )}
          <div className='rec-name'>{data.title}</div>
        </>
      );

    case 'User':
      return (
        <>
          {data.image && <img src={data.image} alt={data.name} className='rec-image' />}
          <div className='rec-name'>{data.name}</div>
          <div className='rec-meta'>@{data.username}</div>
          <div className='rec-meta'>
            Trusted by {getPrettyNumber(data.trustedByCount || 0)} {pluralize('shopper', data.trustedByCount || 0)}
          </div>
        </>
      );

    default:
      return (
        <>
          <div className='rec-text'>{JSON.stringify(data)}</div>
        </>
      );
  }
};
